import type { LocaleMessages } from '../types';

export const ru: LocaleMessages = {
  app: {
    brand: 'ACEX · Биржа капитала агентов',
    title: 'Pulse Terminal',
  },
  locale: {
    label: 'Язык',
  },
  header: {
    chain: 'Сеть',
    refresh: 'обновление {ms}мс',
    chainFilterUniOnly: 'Фильтр сети только в режиме LIVE',
  },
  contour: {
    live: 'LIVE',
    uni: 'UNI',
    liveBadge: 'LIVE · {mode}',
    uniBadge: 'UNI · {phase}',
  },
  dataSource: {
    live: {
      label: 'LIVE · Factory / Hub',
      formula:
        'Возможности продукта (каталог hub) → средние ACEX v0.2 по листингу; фильтр сети по capabilities',
    },
    uni: {
      label: 'UNI · Alien Monitor',
      formula:
        'Метрики графа → прокси $/call → ACEX v0.2 (NAV = $/call × success × trust × 100; index = $/call × success × 1000)',
    },
  },
  dataSourceBar: {
    loading: 'загрузка…',
  },
  error: {
    uniHint: 'запустите Alien Monitor (/monitor/, режим UNI)',
    liveHint: 'нужен API /api/v2/capital/pricing (factory :9081)',
  },
  panel: {
    agentListings: 'Листинги агентов',
    agentListingsSub: 'CapShares · live NAV',
    universeListings: 'Узлы вселенной',
    universeListingsSub: 'Контур UNI · граф Alien Monitor',
    agentListing: 'Листинг агента',
    selectRow: 'выберите строку',
    selectHint:
      'Выберите листинг, чтобы посмотреть CapShare NAV, компоненты индекса и серии CapSense.',
    listingFallback: 'Листинг',
  },
  listings: {
    emptyLive: 'Нет листингов — запустите pipeline фабрики или hub с capabilities',
    emptyUni: 'Нет узлов вселенной — запустите Alien Monitor (режим UNI)',
    caps: '{count} caps',
    capabilities: '{count} capabilities',
    capShareNav: 'CapShare NAV',
    trust: 'trust {pct}%',
    idx: 'idx {value}',
    details: 'Подробнее →',
    colListing: 'Листинг',
    colCapShare: 'CapShare',
    colIndex: 'Индекс',
    colIv: 'IV',
    colTrust: 'Trust',
    colAudit: 'Аудит',
    colRoute: 'Маршрут',
    colTrend: 'Тренд',
    iv: 'IV {pct}%',
    uncovered: 'без покрытия',
    watch: 'watch',
  },
  detail: {
    uniSubtitle: 'UNI · NAV из графа монитора (ACEX v0.2)',
    liveSubtitle: 'LIVE · CapShare из capabilities продукта',
    capShareNav: 'CapShare NAV',
    indexLevel: 'Уровень индекса',
    iv: 'IV',
    pricePerCall: '$/call',
    success30d: 'Success 30d',
    trustScore: 'Trust score',
    reliability: 'Надёжность',
    indexComponents: 'Компоненты индекса',
    change24h: '24ч {value}',
    capsenseTitle: 'CapSense Options',
    capsenseSub: 'Фаза 2 · Solana',
    openSeries: 'Открытые серии',
    capsenseHint: 'Call на revenue index · экспирации {days}д',
    liquidityTitle: 'Liquidity mesh',
    liquiditySub: 'маршрутизация',
    poaTitle: 'Proof-of-Audit',
    poaSub: 'стейк аудиторов · доля invoke fee',
    insured: 'Застрахован',
    noCover: 'Без покрытия',
    aggregateScore: 'Сводный score',
    totalCover: 'Общее покрытие',
    auditors: 'Аудиторы',
    auditFee: 'Audit fee',
    accruedRewards: 'Начисленные rewards',
    noteSpread: 'Note spread',
    baseline: 'Baseline {value}',
    twap: 'TWAP {value}',
    drawdown: 'просадка {pct}%',
    coverLine: 'cover {value}',
    scoreLine: 'score {pct}%',
    pendingLine: 'pending {value}',
  },
  defaultRisk: {
    none: 'Риск дефолта: низкий',
    watch: 'Риск дефолта: watch',
    elevated: 'Риск дефолта: elevated',
    defaulted: 'Риск дефолта: defaulted',
  },
  statusBar: {
    acex: 'ACEX {version}',
    listings: '{count} листингов',
    latency: '{ms}мс',
    navSum: 'Σ NAV {value}',
    version: 'Pulse v0.1',
  },
  mobile: {
    close: 'Закрыть',
  },
  ticker: {
    uni: 'uni',
  },
};
